export default {
  "apiRateLimitExceede": "You are doing this too often. Please try later.",
  "Recent": "Recent",
  "Starred": "Starred",
  "Mycloud": "My Cloud",
  "Myshare": "Shared with me",
  "Ucenter": "User Center",
  "Feedback": "Feedback",
  "Exit": "Logout",
  "Searchword": "Search Document",
  "Mystorage": "My Storage",
  "New": "New",
  "Newdoc": "New Writer Document",
  "Newxls": "New Spreadsheets Document",
  "Newppt": "New Presentation Document",
  "Newfolder": "New Folder",
  "Upload": "Upload",
  "Upfile": "Upload File",
  "Upfolder": "Upload Folder",
  "Cloud": "Auto Uploaded",
  "Newfolderlabel": "Folder name",
  "Newfolderinfo": "Please enter folder name",
  "Movefile": "Move file",
  "Loading": "loading...",
  "Confirm": "OK",
  "Cancel": "Cancel",
  "From": "from",
  "Recently": "Recently",
  "Minago": "{time} minutes ago",
  "Hourago": "{time} hours ago",
  "Dayago": "{time} days ago",
  "Monthago": "{time} months ago",
  "Yearago": "{time} years ago",
  "Share": "Share",
  "Cancelselect": "Clear selection",
  "Delete": "Delete",
  "DeleteSuc": "Delete success",
  "errInter": "Network error",
  "Deleterecord": "Delete Record",
  "Delrecordtip": "Please sure to delete",
  "Selectedfiles": "the files you selected",
  "Delfilestoo": "Delete file at the same time",
  "file_create": "added file",
  "file_comment": "commented on",
  "file_delete": "deleted file",
  "file_update": "updated file",
  "file_recover": "recovered file",
  "file_rename": "renamed file",
  "I": "I",
  "Copy": "Copy",
  "Move": "Move",
  "Download": "Download",
  "Nofiles": "No file",
  "Nofilestip": "You can drag files here, or",
  "UploadNew": "Upload File",
  "UploadnewVer": "Upload new version",
  "Versiontip": "WPS Cloud keeps a historical version for your every edit of the file.",
  "Position": "Location",
  "ServerError": "Server error",
  "InvalidArgument": "Invalid argument",
  "Notfound": "The page you are trying to open does not exist.",
  "Backhome": "Return to Home",
  "Uploadfailed": "Upload failed",
  "fileNameConflict": "A file with this name already exists.",
  "Created": "Created.",
  "deleteFiles": "Delete the {num} files selected",
  "deleteFile": "Delete File",
  "Deletefiletip": "Sure to delete",
  "deleteSucc": "File deleted",
  "Copyto": "Copy file to",
  "Downloadall": "Batch download",
  "Copysuccess": "File copied",
  "copyFileFail": "Copy failed",
  "MoveFiles": "Move {num} files selected",
  "MoveFile": "Move file to",
  "Movesuccess": "File moved",
  "Uploading": "Uploading",
  "Uploaded": "Upload completed",
  "Openfolder": "Open folder",
  "Failedlen": "{len} failed",
  "Newfile": "New File",
  "fileNameEmpty": "Filename cannot be empty.",
  "Newfileinfo": "please enter filename",
  "Newfilelabel": "File name",
  "Nostaradd": "The files with",
  "Nostartip": "will be displayed here.",
  "Norecent": "Here are the files you recently opened or edited.",
  "Trash": "Recycle Bin",
  "Auto": "Auto Uploaded",
  "ASCfname": "Name A-Z",
  "DESCfname": "Name Z-A",
  "ASCmtime": "Old Files first",
  "DESCmtime": "New Files first",
  "Sort": "Sort",
  "Emptytrash": "Empty Recycle Bin",
  "Emptytrashsure": "Sure to empty recycle bin?",
  "Emptied": "Emptied",
  "Notrash": "Files in recycle bin will be permanently deleted in 30 days",
  "Noauto": "Files opened by WPS Office on all devices are automatically saved here for your convenience.",
  "permissionDenied": "Permission denied",
  "Nosearch": "No result for \"{search}\"",
  "Anyone": "Anyone who got the link can visit",
  "Expire": "Expires date",
  "Forever": "Forever",
  "Copylink": "Copied",
  "Copyerror": "Copy failed",
  "Events": "Events",
  "Me": "Me",
  "Back": "Back",
  "More": "More",
  "Renamefile": "Rename file",
  "Comment": "Publish",
  "Commented": "Commented",
  "Eventslabel": "All file events",
  "Commentholer": "Comment on the file",
  "Deletecom": "Delete  Comment",
  "Deleteinfo": "Sure to delete comment?",
  "Deletecomsuc": "Comment deleted",
  "Previewfailed": "Preview Failed",
  "fileNotExists": "The file does not exist.",
  "error": "Error",
  "downfail": "This file has failed several download attempts. Recommend download to view.",
  "largefile": "This file is too large to preview. You could download to view.",
  "convertfail": "This file has failed several convert attempts. Recommend download to view.",
  "unsupport": "Cannot preview. Please download to view.",
  "unsupporttype": "This file format connot be previewed.",
  "filetimeout": "File load timeout. Please try later.",
  "notupload": "This file failed to upload on client. Please check and try again.",
  "invitecodeError": "Wrong password. Please reenter.",
  "converTimeout": "Convert timeout",
  "Renamed": "Renamed",
  "fileNameNotChanged": "Please enter a different file name",
  "Version": "Version {fver}",
  "Hiscurrent": "current",
  "Unmatched": "The file type you upload is not the same as the current file.",
  "Emptyfile": "Empty file",
  "Recover": "Recover",
  "Mon": "Monday",
  "Tue": "Tuesday",
  "Wed": "Wednesday",
  "Thu": "Thursday",
  "Fri": "Friday",
  "Sat": "Saturday",
  "Sun": "Sunday",
  "Dorecover": "Sure to recover the file changed at {date} {week} {time}.",
  "Recoversuc": "Successfully recovered",
  "Star": "Star",
  "Unstar": "Unstar",
  "Rename": "Rename",
  "History": "History version",
  "Deletefoever": "Delete Permanently",
  "Recovertitle": "Recover {type}",
  "Recoverinfo": "Sure to recover {type} 「{name}」",
  "Recovered": "File recovered",
  "Brecoverinfo": "Recover the selected {len} files?",
  "Deleteftitle": "Delete {type} permanently",
  "Deletefinfo": "Sure to permanently delete 「{name}」",
  "Deletefsinfo": "Are you sure to permanently delete the selected {len} files",
  "file_shift_in": "moved in file",
  "WPS": "WPS Cloud",
  "Localopen": "Local app open",
  "Localopeninfo": "Local application editingfunction needs to install WPS client under Windows system ",
  "Recentsearch": "Recent search",
  "Clear": "Empty",
  "Norecord": "No search history",
  "Search": "Search",
  "moveFilesFail": "Move failed",
  "MessengerRenameDenied": "Messenger folder can't be renamed",
  "Upcancel": "Canceled",
  "Oldversion": "Change To Old Version",
  "Overview": "Overview",
  "DocNotExist": "The document you have requested does not exist",
  "Shared": "shared",
  "InvalidFileId": "Network error",
  "moveFileSelfPermission": "File location has not changed",
  "Submit": "Submit",
  "Qtype": "Question Type",
  "Cannotpreview": "File cannot be previewed.",
  "Contentp": "The layout is confusing and the file display is incomplete.",
  "Other": "Other",
  "Qdesc": "Problem Description",
  "Pcontent": "Please input your content",
  "Images": "Images",
  "Email": "Email",
  "Econtent": "Please input your email address",
  "Sendaddress": "Send the preview address(used to find preview issues)",
  "Feedtip": "You can add nine pictures at most.",
  "Overlimit": "You can add nine pictures at most.",
  "Thanks": "Thanks for your feedback",
  "Noshare": "You have not received any shared files yet.",
  "Subfiled": "Feedback failed, please try again later.",
  "Empty": "Empty {fname}",
  "Emptyfolder": "Empty folder",
  "Emptyfoldersure": "Sure to empty ",
  "Errimg": "Error image format",
  "fileNameLengthExceed": "Filename cannot be longer than 100 characters.",
  "deleteFilePermission": "Permission denied",
  "LinkNotExist": "The link does not exist.",
  
  "Anyedit": "Anyone who got the link can edit",
  "Someone": "The specified user has access rights",
  "Stopshare": "Stop Sharing",
  "Thdays": "3 days",
  "Sedays": "7 days",
  "Thtdays": "30 days",
  "Stoptip": "Other people will not be able to view or edit documents after you stop sharing",
  "Off": "Document sharing is off",
  "Start": "Open sharing",
  "edit": "Edit",
  "view": "View",
  "Remove": "Remove",
  "InivieTip": "Invite others to view/edit",
  "Joined": "people joined",
  "Selectedusers": "{num} selected users",
  "Emptytip": "Please select the member you want to add",
  "Success": "Success",
  "Teams": "Team",
  "NewTeam": "Create Team",
  "MemberVisit": "{num} member(s) can visit",
  "AddMember": "Add members",
  "MemberLength": "{num} member(s)",
  "JoinTip": "After joining, you can view, edit and manage documents with team members",
  "ConfirmJoin": "Confirm to join",
  "JoinFooter": "Provided by the WPS cloud service",
  "TeamTip": "Share team documents and accomplish collaborative tasks",
  "NewTeamNow": "Create team now",
  "TeamBlock1": "Upload anytime anywhere",
  "STeamBlock1": "Synchronize with members' document",
  "TeamBlock2": "Set permissions for members",
  "STeamBlock2": "Secure team files",
  "TeamBlock3": "More team apps",
  "STeamBlock3": "Meet the needs of teamwork",
  "TeamLabel": "Team name",
  "TeamPlaceholder": "{name}'s team",
  "TeamNotExists": "The team no longer exists",
  "TeamMember": "The team members",
  "Madmin": "Administrator",
  "Mcreator": "Creator",
  "Mmember": "Editable",
  "Mread_member": "Read only",
  "Settings": "Team settings",
  "TeamName": "Team name",
  "SetBtn": "Settings",
  "CheckBtn": "View",
  "Mmanager": "Member management",
  "ExitTeam": "Delete and exit",
  "SelectContacts": "Choose from contact list",
  "ExitTeamCheck": "Empty folder",
  "ExitConfirm": "Remove all files on exit",
  "ExitTip": "After deleting and exiting, the member will be inaccessible",
  "UserExitTip": "After deleting and exiting, you will not be able to access the Shared folder",
  "DeleteTip": "After deleting and exiting the team, you will no longer be able to access the team",
  "TeamFiles": "Team Files",
  "illegalFname": "Name cannot contain illegal characters and special symbols such as \\/:*? \"< > |",
  "groupLengthTooLong": "Name cannot exceed 50 characters",
  "group_create": "created group",
  "folderNotExists": "Folder does not exist",
  "file_shift_out": "removed file",
  "group_rename": "changed team name",
  "InviteTo": "Invite to be:",
  "group_member_join_by_link": "joined the team (link invitation)",
  "group_member_role_upgrade": "promoted to administrator",
  "group_member_delete": "removed member",
  "MemberTip": "Only administrators can invite members to join",
  "NoPermission": "No permission to operate the current directory, please contact the administrator",
  "teamLinkNotExist": "Invalid team link",
  "GroupMemberExists": "Team member already exists",
  "group_member_quit": "left the team",
  "notGroupMember": "Not a member",
  "ClientOpen": "Open WPS Office",
  "groupNotExist": "Group not exists",
  "UserNotExists": "User not exists",
  "NotSameRegion": "Sorry, you're not allowed to join this team, because you are not in the same area with the team owner.",
  "File": "File",
  "EmailTip": "Your email address is unverified. Please check the activation email we have sent you.",
  "Resend": "send again",
  "SendEmail": "Send email success",
  "SendSuccess": "We have sent a verification email to {email}. \nGo to open email.",
  "Opening": "WPS Office will be opening. If not opened properly please",
  "Install": "Install WPS Office",
  "SharedByMe": "Shared by me",
  "ShareMenu": "Sharing",
  "SharedByMeEmpty": "Files you share with others will appear here",

  "W2P": "Word to PDF",
  "E2P": "Excel to PDF",
  "PP2P": "PPT to PDF",
  "P2W": "PDF to Word",

  "permissionTip": "Prevent people with this link from downloading."
}


// WEBPACK FOOTER //
// ./src/i18n/langs/en-US.js